export function createUrl(usersNotFoundList?: string[]): string {
  return `data:text/json;charset=utf-8,${encodeURIComponent(
    usersNotFoundList?.join('\r') ?? JSON.stringify(usersNotFoundList),
  )}`;
}
